<div class="ibox">
  @if (hasTitle) {
    <div class="ibox-title"
         (click)="isCollapsible ? (collapsed = !collapsed) : false"
         (keydown.enter)="isCollapsible ? (collapsed = !collapsed) : false"
         [ngClass]="[isCollapsible ? 'ibox-title-collapsible' : '']"
      >
      @if (boxTitle) {
        <h5>
          {{ boxTitle }}
        </h5>
      }
      @if (!boxTitle) {
        <ng-content select=".my-ibox-title"></ng-content>
      }
      <ng-content select=".my-ibox-addl-title"></ng-content>
      @if (isCollapsible) {
        <i class="ibox-icon fa fa-chevron-down"></i>
      }
    </div>
  }
  @if (!collapsed) {
    <div class="ibox-content">
      <ng-content select=".my-ibox-content"></ng-content>
    </div>
  }
</div>
